<template>
  <div class="Tab">
    <el-table :data="tableData">
      <el-table-column prop="orderNumber" :index="NIndex" label="订单ID" width="210">
      </el-table-column>
      <el-table-column :label="'企业名称\n(统一社会信用代码)'" width="220"
        ><template slot-scope="scope">
          <div>{{ scope.row.orderCompanyName }}</div>
          <div>({{ scope.row.orderCreditCode }})</div>
        </template></el-table-column
      >
      <el-table-column
        prop="operationTypeName"
        label="服务类型"
        show-overflow-tooltip width="120"
      >
      </el-table-column>
      <el-table-column label="服务类别" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.iprTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业类型" prop="orderCompanyTypeName">
      </el-table-column>

      <el-table-column label="状态" 
        ><template slot-scope="scope">
          <span :class="$tool.getProxyStatusClass(scope.row)" :style="{ color: $tool.getProxyStatusColor(scope.row) }">{{ scope.row.statusName }}</span>
        </template></el-table-column
      >
      <el-table-column prop="createTime" label="提交时间" show-overflow-tooltip width="180">
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <span class="span-Operation" @click="handelDetails(0, scope.row)"
            >详情信息</span
          >
          <span
            class="span-Operation"
            @click="handelDetails(1, scope.row)"
            v-if="scope.row.refundButton == true"
            >申请退款</span
          >
          <span
            class="span-Operation"
            @click="handelHesitation(scope.row)"
            v-if="scope.row.refundButton == true"
            >立即办理</span
          >
          <span
            class="span-Operation"
            @click="handelEvaluation(scope.row)"
            v-if="scope.row.taskStatus == 3"
            >服务评价</span
          >
          <!-- <span
            class="span-Operation"
            v-if="scope.row.taskStatus == 3"
            @click="handelAndLeProcess(1, scope.row)"
            >重新提交</span
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 立即办理弹窗 -->
    <Hesitation
      :VisibleHesitation="VisibleHesitation"
      @handleCloseHesitation="VisibleHesitation = false"
      @handleUnHesitation="handleUnHesitation"
    ></Hesitation>
  </div>
</template>

<script>
import Hesitation from "../../../Bookkeeping/components/IndexCom/Hesitation.vue"; //立即办理弹窗
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    tableData: {},
    BidDocument: {},
    pagingObj: {},
  },

  // 组件状态值
  data() {
    return {
      VisibleHesitation: false, //立即办理弹窗
      Details: {}, //被操作项的详情数据
    };
  },
  watch: {
    // // 监听
    // visibleImport: {
    //   handler(newSs, old) {},
    //   immediate: false,
    // },
  },
  components: {
    Hesitation, //立即办理弹窗
  },
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    // 列表刷新
    Refresh() {
      this.$emit("Refresh");
    },
    // 立即办理确定
    handleUnHesitation() {
      this.$tool
        .InvoiceProcess(
          "/global/proxy/iprProcess",
          this.Details.orderNumber
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.Refresh();
          }
        });
      this.VisibleHesitation = false;
    },
    //立即办理
    handelHesitation(row) {
      if (!this.$checkAction()) return
      this.Details = row;
      this.VisibleHesitation = true;
    },
    // 服务评价
    handelEvaluation(row) {
      this.$emit("handelEvaluation", row);
    },
    // 列表 - 查看
    handelDetails(num, row) {
      this.$emit("handelDetails", num, row);
    },
    // 列表重新提交
    handelAndLeProcess(num, row) {
      this.$emit("handelAndLeProcess", num, row);
    },

    //表格分页序号
    NIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.pagingObj.currentPage; // 当前页码
      const pagesize = this.pagingObj.pageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
// .el-table_1_column_2
// /deep/ .cell {
//   white-space: pre-line !important;
//   text-align: center;
// }
.Tab {
  width: 100%;
  .span-Operation {
    color: #409eff ;
    margin-left: 10px;
    cursor: pointer;
  }
  .span-Operation:nth-child(1) {
    margin-left: 0px;
  }
}
</style>
